import React from 'react';
import { Link, Outlet } from 'react-router-dom';

import adriagate_logo from 'assets/img/adriagate_logo.svg';
import logo from 'assets/img/logo.svg';
import { isAdriagate } from 'modules/_common';

import { Content, Header, Logo } from './PublicLayout.styled';

export const PublicLayout = () => {
  return (
    <>
      <Header>
        <Logo>
          <Link to="/">
            <img src={isAdriagate ? adriagate_logo : logo} alt="logo" />
          </Link>
        </Logo>
      </Header>
      <Content>
        <Outlet />
      </Content>
    </>
  );
};
